import { jsx as _jsx } from "react/jsx-runtime";
import { ptBR } from "date-fns/locale";
import { DayPicker } from "react-day-picker";
import { tv } from "tailwind-variants";
import Icon from "../../icons";
import { buttonVariants } from "../Button/Button";
const calendarVariants = tv({
    slots: {
        root: "relative w-fit",
        weekdays: "flex mt-3",
        weekday: "size-8 text-center text-xs font-normal capitalize",
        weeks: "flex flex-col gap-1",
        monthGrid: "gap-1",
        month: "group/month",
        months: "flex relative gap-6",
        captionLabel: "text-sm font-medium w-full h-8 flex items-center justify-center capitalize",
        nav: "absolute w-full top-0 left-0 flex items-center justify-between",
        day: [
            // Base button variants
            buttonVariants({ variant: "text", color: "default", icon: true, size: "sm" }),
            // Base day styles
            "inline-flex rounded-none cursor-pointer",
            "hover:[&:not([aria-selected])]:rounded-md",
            // Selected day styles
            "aria-selected:bg-primary-6 aria-selected:text-white",
        ],
        dayButton: "size-full rounded-md",
        today: "text-primary !font-bold",
        outside: "text-gray-6",
        disabled: "!text-gray-6 bg-gray-2 pointer-events-none",
        // Range specific styles
        rangeEnd: "range range-end",
        rangeStart: "range range-start",
        rangeMiddle: "range-middle",
        // Navigation buttons
        buttonNext: buttonVariants({ variant: "outlined", color: "default", icon: true, size: "sm" }),
        buttonPrevious: buttonVariants({ variant: "outlined", color: "default", icon: true, size: "sm" }),
    },
    variants: {
        mode: {
            // Single mode specific styles
            single: {
                captionLabel: "",
                day: "aria-selected:rounded-md aria-selected:bg-primary aria-selected:font-bold aria-selected:text-white",
            },
            // Range mode specific styles
            range: {
                captionLabel: "w-[calc(100%-32px)] group-first-of-type/month:ml-8",
                day: [
                    "[&.range>button]:bg-primary",
                    "[&.range]:bg-primary [&.range]:text-white [&.range]:font-bold",
                    "[&.range-start]:rounded-l-md",
                    "[&.range-end]:rounded-r-md",
                    "[&.range-middle]:text-primary-11",
                ],
            },
            // This mode is not used in the component
            multiple: {},
        },
    },
});
const Calendar = ({ className, classNames, showOutsideDays = false, numberOfMonths = 1, ...props }) => {
    const { root, weekdays, weekday, weeks, monthGrid, month, months, captionLabel, nav, day, dayButton, today, outside, disabled, rangeEnd, rangeStart, rangeMiddle, buttonNext, buttonPrevious, } = calendarVariants({
        mode: props.mode,
    });
    return (_jsx(DayPicker, { ...props, "data-testid": "calendar", locale: ptBR, showOutsideDays: showOutsideDays, numberOfMonths: props.mode === "range" ? 2 : numberOfMonths, className: className, classNames: {
            root: root(),
            weekdays: weekdays(),
            weekday: weekday(),
            weeks: weeks(),
            month_grid: monthGrid(),
            month: month(),
            months: months(),
            caption_label: captionLabel(),
            nav: nav(),
            day: day(),
            day_button: dayButton(),
            today: today(),
            outside: outside(),
            disabled: disabled(),
            range_end: rangeEnd(),
            range_start: rangeStart(),
            range_middle: rangeMiddle(),
            button_next: buttonNext(),
            button_previous: buttonPrevious(),
            ...classNames,
        }, components: {
            Chevron: ({ orientation, className }) => _jsx(Icon, { name: orientation === "right" ? "arrow-right" : "arrow-left", className: className }),
        } }));
};
Calendar.displayName = "Calendar";
export default Calendar;
